import { gsap } from '../global/gsap';

const initMenu = (element) => {
    const body = document.querySelector('.js-body');
    const menuToggle = element.querySelectorAll('.js-menu-button');
    const menuClose = element.querySelector('.js-menu-close');
    const navItems = element.querySelectorAll('.js-nav-items li');
    const subNavs = element.querySelectorAll('.js-subnav');
    const stopScrollingClass = 'menu-active';
    const isActiveClass = 'is-active';
    let isActive = false;

    let menuTl;

    let mm = gsap.matchMedia();

    mm.add('(max-width: 899px)', () => {
        menuTl = gsap.timeline({ paused: true });

        menuTl.from(menuClose, {
            rotate: -235,
            duration: 0.8,
            ease: 'power3.out'
        });

        menuTl.from(navItems, {
            autoAlpha: 0,
            xPercent: -20,
            duration: 1,
            stagger: 0.02,
            ease: 'power3.inOut',
        }, '-=.65');

        menuTl.from(subNavs, {
            autoAlpha: 0,
            yPercent: 50,
            duration: 1,
            stagger: 0.1,
            ease: 'power3.inOut',
        }, '-=0.75');

        return () => {
            if (menuTl) {
                menuTl.kill();
            }
            gsap.set([menuClose, navItems, subNavs], { clearProps: 'all' });
            menuTl = null;
        };
    });

    menuToggle.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            isActive = !isActive;

            if (isActive) {
                body.classList.add(stopScrollingClass, isActiveClass);
                if (menuTl) menuTl.restart();
            } else {
                body.classList.remove(stopScrollingClass, isActiveClass);
                if (menuTl) menuTl.reverse();
            }
        });
    });
};

export { initMenu as default };